import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Policy extends Component {
  render() {
    const { policy, show } = this.props
    return (
      <li
        id={policy.slug}
        className={show ? 'policy-list-item active' : 'policy-list-item'}
      >
        <div
          className="policy-content"
          dangerouslySetInnerHTML={this.createHtmlElement(policy.content_html)}
        ></div>
      </li>
    )
  }

  createHtmlElement(html) {
    return { __html: html }
  }
}

Policy.propTypes = {
  show: PropTypes.bool,
  policy: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/policies/Policy.js